import { render, staticRenderFns } from "./SoundRecordingsList.vue?vue&type=template&id=663f9a1e&"
import script from "./SoundRecordingsList.vue?vue&type=script&lang=js&"
export * from "./SoundRecordingsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports